'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  InfluencerLandingPageModel,
  InfluencerLandingPageEvent,
  landingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { NewIntroductionSection } from './components/IntroductionSection/NewIntroductionSection'
import { NewLifestyleSection } from './components/LifestyleSection/NewLifestyleSection/NewLifestyleSection'
import { NewClosetSection } from './components/ClosetSection/NewClosetSection'
import { NewTipsSection } from './components/TipsSection/NewTipsSection'
import { NewInspirationSection } from './components/InspirationSection/NewInspirationSection'
import { DisclaimerSection } from './components/DisclaimerSection'

type Props = {
  content: InfluencerLandingPageModel
}

const NewTheWardrobeEdit = ({ content }: Props) => {
  const { track } = useTracking()

  useEffect(() => {
    const trackLandingPageView = async () =>
      track(
        landingPageEvent({
          event: InfluencerLandingPageEvent.PageView,
          referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
          deviceId: await getFingerprint(),
        }),
      )

    trackLandingPageView()
  }, [track])

  return (
    <div className="influencer-v2-landing-page">
      <NewIntroductionSection data={content.introduction} />
      <NewLifestyleSection data={content.lifestyle} />
      <NewClosetSection data={content.closet} />
      <NewTipsSection data={content.tips} />
      <NewInspirationSection data={content.inspiration} />
      <DisclaimerSection data={content.disclaimer} />
    </div>
  )
}

export default NewTheWardrobeEdit
